import {
  ContragentSignDocumentSignDeviceStrategy,
  ContragentSignDocumentSignFileSystemStrategy,
  ContragentSignDocumentSignDepositSignLoginPswStrategy,
  ContragentSignDocumentSignDiiaStrategy,
  ContragentSignDocumentSignCloudKeyFileSystemStrategy,
  ContragentSignDocumentSignWithQrCloudProviderStrategy,
  ContragentSignDocumentSignWithIdCloudProviderStrategy
} from '@/sign/strategies/contragent-sign-document-sign-private-key.strategy';
import { SignStrategyFactory } from './sign-strategy.factory';

export class ContragentSignDocumentSignStrategyFactory extends SignStrategyFactory {
  constructor() {
    super(
      ContragentSignDocumentSignFileSystemStrategy,
      ContragentSignDocumentSignDeviceStrategy,
      ContragentSignDocumentSignDepositSignLoginPswStrategy,
      ContragentSignDocumentSignDiiaStrategy,
      ContragentSignDocumentSignCloudKeyFileSystemStrategy,
      ContragentSignDocumentSignWithQrCloudProviderStrategy,
      ContragentSignDocumentSignWithIdCloudProviderStrategy);
  }
}
